import { ca } from '@cian/analytics';

import { CONCLUSION_TYPE_TO_ANALYTICS_LABEL_MAP } from '../../../constants/analytics';
import { EConclusion } from '../../../types/calculate';

export function trackRealtorClick(type: EConclusion) {
  const label = CONCLUSION_TYPE_TO_ANALYTICS_LABEL_MAP[type];

  ca('eventSite', {
    name: 'oldevent',
    action: 'click_demand',
    category: 'invest_calculator',
    label,
  });
}
